import DownloadIcon from '@mui/icons-material/Download'
import { IconButton } from '@mui/material'
import { ReactNode, RefObject } from 'react'
import { useDownloadSnapshot } from '../../hooks/useDownloadSnapshot'

export type SnapshotDownloaderChild = {
  subjectRef: RefObject<HTMLDivElement>
}

type SnapshotDownloaderProps = {
  children(props: SnapshotDownloaderChild): ReactNode
  filename: string
  buttonPosition?: { top: number; right: number }
}

export const SnapshotDownloader = ({
  children,
  filename,
  buttonPosition = { top: 18, right: 18 },
}: SnapshotDownloaderProps) => {
  const { subjectRef, downloadSnapshot, downloadFilename } = useDownloadSnapshot(filename)

  return (
    <div style={{ position: 'relative' }}>
      <IconButton
        color="secondary"
        aria-label={`download ${downloadFilename}`}
        onClick={downloadSnapshot}
        style={{ position: 'absolute', ...buttonPosition }}
      >
        <DownloadIcon />
      </IconButton>

      {children({ subjectRef })}
    </div>
  )
}
